/* eslint-disable @typescript-eslint/member-ordering */
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private readonly navigationChange = new Subject<void>();
  navigationChange$ = this.navigationChange.asObservable();

  triggerNavigationUpdate() {
    this.navigationChange.next();
  }
}
